var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "position-absolute",
      staticStyle: { top: "10px", right: "10px", "z-index": "10" },
    },
    [
      _c(
        "button",
        {
          staticClass:
            "btn rounded d-flex align-items-center justify-content-center favorite-btn",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.toggleFavorite.apply(null, arguments)
            },
          },
        },
        [
          _c("i", {
            class: _vm.favorite
              ? "fas fa-star text-warning"
              : "far fa-star text-white",
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }